import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Icon } from '@digsup/components-icon';
import { Text } from '@digsup/components-text';

const cx = classNames;

export const Subtitle = ({ icon, children, className, ...props }) => {
  const classes = cx('u-margin-bottom-medium', className);

  return (
    <div className={classes} style={{ textAlign: 'center' }} {...props}>
      {icon && (
        <Icon
          name={icon}
          fill="white"
          shapeColor="tenacious"
          shape="round"
          size="large"
          className="u-margin-bottom-small"
        />
      )}
      <Text
        size="2xs"
        fontFamily="serif"
        fontWeight="semibold"
        align="center"
        marginBottom="none">
        {children}
      </Text>
    </div>
  );
};

Subtitle.propTypes = {
  icon: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
};

Subtitle.defaultProps = {
  className: 'u-margin-bottom-medium',
};
